import * as React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Box } from '@mui/material';
import { useState } from 'react';
import CareerSchoolFormContainer from '../../../containers/employeemng/personal/CareerSchoolFormContainer';
import CareerSchoolListContainer from '../../../containers/employeemng/personal/CareerSchoolListContainer';
import FamilyInfoFormContainer from '../../../containers/employeemng/personal/FamilyInfoFormContainer';
import FamilyInfoListContainer from '../../../containers/employeemng/personal/FamilyInfoListContainer';
import EtcListContainer from '../../../containers/employeemng/personal/EtcListContainer';
import EtcFormContainer from '../../../containers/employeemng/personal/EtcFormContainer';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`personal-tabpanel-${index}`}
      aria-labelledby={`personal-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `personal-tab-${index}`,
    'aria-controls': `personal-tabpanel-${index}`,
  };
}

const PersonalTabs = ({ employee, edit }) => {
  const [selectTab, setSelectTab] = useState(0);
  const handleChange = (event, newTab) => {
    setSelectTab(newTab);
  };
  return (
    <div>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={selectTab}
            onChange={handleChange}
            aria-label="personaln tabs"
          >
            <Tab label="학교" {...a11yProps(0)} />
            <Tab label="가족정보" {...a11yProps(1)} />
            <Tab label="기타사항" {...a11yProps(2)} />
          </Tabs>
        </Box>
        <TabPanel value={selectTab} index={0}>
          {edit && <CareerSchoolFormContainer employee={employee} />}
          <CareerSchoolListContainer employee={employee} />
        </TabPanel>
        <TabPanel value={selectTab} index={1}>
          {edit && <FamilyInfoFormContainer employee={employee} />}
          <FamilyInfoListContainer employee={employee} />
        </TabPanel>
        <TabPanel value={selectTab} index={2}>
          {edit && <EtcFormContainer employee={employee} />}
          <EtcListContainer employee={employee} />
        </TabPanel>
      </Box>
    </div>
  );
};

export default PersonalTabs;
